import React from 'react';

interface LoadingSpinnerProps {
  size?: string;
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size, message }) => {
  return (
    <div className={`flex flex-col items-center justify-center ${size ? `h-${size} w-${size}` : 'h-full w-full'}`}>
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      <span className="mt-3 text-gray-600">
        {message || 'Loading...'}
      </span>
    </div>
  );
};

export default LoadingSpinner;
